import { Component, OnInit } from '@angular/core';
import { Country } from 'src/models/country';
import { ActivatedRoute } from '@angular/router';
import { ListStreamsI } from '../../base/list-streams/list-streams-i';
import { Stream } from 'src/models/stream';
import { Observable } from 'rxjs/internal/Observable';
import { StreamService } from 'src/app/services/stream.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit, ListStreamsI {

  public countries = new Array<Country>();

  public countryId: string;

  constructor(private activatedRoute: ActivatedRoute, private streamService: StreamService) {}

  ngOnInit() {
    this.streamService.getCountriesWithNewsStations().subscribe((value: Country[]) => {
      this.countries = value;
    });

    this.activatedRoute.queryParams.subscribe(params => {
      this.countryId = params['id'];
    });
  }

  public getHeadline(): string {
    const country = this.countries.find((country: Country) => country.id === this.countryId);

    return country !== undefined ? country.name : 'Alle';
  }

  public getStreamsObservable(start: number, itemsPerPage: number): Observable<Stream[]> {
    const observable = this.countryId !== undefined
                            ? this.streamService.getNewsStationsByCountry(this.countryId, start, itemsPerPage)
                            : this.streamService.getStationsByCategory(14, start, itemsPerPage);

    return observable;
  }

}
